export default {
    ACTIVE: 0,
    DISABLE: 1,
    PENDING_TO_REDIRECT: 2,
    REDIRECTED: 3,
    PRODUCT_DELETED: 4,
    PROMOTION_DELETED: 5,
}